/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateExpenseTypeRequest
 */
export interface CreateExpenseTypeRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateExpenseTypeRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateExpenseTypeRequest
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateExpenseTypeRequest
     */
    color?: string;
}

/**
 * Check if a given object implements the CreateExpenseTypeRequest interface.
 */
export function instanceOfCreateExpenseTypeRequest(value: object): value is CreateExpenseTypeRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateExpenseTypeRequestFromJSON(json: any): CreateExpenseTypeRequest {
    return CreateExpenseTypeRequestFromJSONTyped(json, false);
}

export function CreateExpenseTypeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateExpenseTypeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'icon': json['icon'] == null ? undefined : json['icon'],
        'color': json['color'] == null ? undefined : json['color'],
    };
}

export function CreateExpenseTypeRequestToJSON(json: any): CreateExpenseTypeRequest {
    return CreateExpenseTypeRequestToJSONTyped(json, false);
}

export function CreateExpenseTypeRequestToJSONTyped(value?: CreateExpenseTypeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'icon': value['icon'],
        'color': value['color'],
    };
}

